import React from 'react';

import Select from '@atlaskit/select';

import { CodeReviewerFeedbackType } from 'src/components/code-reviewer-feedback/src/types';
import { useIntl } from 'src/hooks/intl';

import messages from '../i18n/request-additional-feedback.i18n';

interface Option {
  label: string;
  value: string;
}
export const TypeSelect = ({
  onChange,
  id,
  ...rest
}: Partial<typeof Select<Option>> & {
  id: string;
  onChange: React.Dispatch<
    React.SetStateAction<CodeReviewerFeedbackType | undefined>
  >;
}): JSX.Element => {
  const { formatMessage } = useIntl();

  // This type assertion is necessary to keep the typechecker happy on build
  const stringToFeedbackType = (
    stringVal: string
  ): CodeReviewerFeedbackType | undefined => {
    switch (stringVal) {
      case CodeReviewerFeedbackType.GENERATED_CONTENT:
        return CodeReviewerFeedbackType.GENERATED_CONTENT;
      case CodeReviewerFeedbackType.UI:
        return CodeReviewerFeedbackType.UI;
      case CodeReviewerFeedbackType.SUGGESTION:
        return CodeReviewerFeedbackType.SUGGESTION;
      case CodeReviewerFeedbackType.STUCK:
        return CodeReviewerFeedbackType.STUCK;
      default:
        return undefined;
    }
  };

  return (
    <Select<Option>
      inputId={id}
      placeholder="Choose a category"
      styles={{ menu: base => ({ ...base, zIndex: 400 }) }}
      {...rest}
      options={[
        {
          label: formatMessage(messages.generatedContent),
          value: CodeReviewerFeedbackType.GENERATED_CONTENT,
        },
        {
          label: formatMessage(messages.ui),
          value: CodeReviewerFeedbackType.UI,
        },
        {
          label: formatMessage(messages.suggestion),
          value: CodeReviewerFeedbackType.SUGGESTION,
        },
        {
          label: formatMessage(messages.stuck),
          value: CodeReviewerFeedbackType.STUCK,
        },
      ]}
      isClearable
      onChange={e => onChange(e ? stringToFeedbackType(e.value) : undefined)}
    />
  );
};
